import { ILocalization } from "bernie-l10n";
import { CheckPricesLocalizationProps, DealProps } from "./typings";
import { isPolygon } from "src/components/utility/LocationUtils";
import { Deal } from "src/typings/microserviceModels/check-prices-flex-module";

// Localization utils
export const modelKeyToDealTextMap = {
  bestWeekend: (l10n: ILocalization) => l10n.formatText("checkPrices.title.bestDeal"),
  today: (l10n: ILocalization) => l10n.formatText("checkPrices.title.today"),
  tomorrowNight: (l10n: ILocalization) => l10n.formatText("checkPrices.title.tomorrowNight"),
  thisWeekend: (l10n: ILocalization) => l10n.formatText("checkPrices.title.thisWeekend"),
  nextWeekend: (l10n: ILocalization) => l10n.formatText("checkPrices.title.nextWeekend"),
};

export const a11yKeyToTextMap = {
  bestWeekend: getLocalizationKey.bind(null, "bestDeal"),
  today: getLocalizationKey.bind(null, "today"),
  tomorrowNight: getLocalizationKey.bind(null, "tomorrowNight"),
  thisWeekend: getLocalizationKey.bind(null, "thisWeekend"),
  nextWeekend: getLocalizationKey.bind(null, "nextWeekend"),
};

function getLocalizationKey(key: string, { regionName, datesLabel, regionType, l10n }: CheckPricesLocalizationProps) {
  const shouldUseNearPreposition = !isPolygon(regionType);
  const closeTo = shouldUseNearPreposition ? ".closeTo" : "";

  return l10n.formatText(`checkPrices.title.${key}.title${closeTo}`, regionName, datesLabel);
}

// Functional Utils
export function buildDatesLabel(l10n: ILocalization, start: string, end: string): string {
  const formatDate = (date: string) => l10n.formatDateString(date, { skeleton: "MMMd" });

  return start && end ? `${formatDate(start)} - ${formatDate(end)}` : "";
}

export function getContent({ l10n, modelKey, model }: Pick<DealProps, "modelKey" | "model" | "l10n">): Deal {
  if (modelKey === "tomorrowNight") {
    const today = new Date();
    const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
    const afterTomorrow = new Date(today.getTime() + 48 * 60 * 60 * 1000);
    const todayLink = model["today"].link; // grabs dateless

    return {
      link: `${todayLink}&startDate=${l10n.formatDateString(tomorrow, {
        raw: "yyyy-MM-dd",
      })}&endDate=${l10n.formatDateString(afterTomorrow, { raw: "yyyy-MM-dd" })}`,
      label: "", // this gets built later on using end and start dates. It's never used
      isoEndDate: l10n.formatDateString(afterTomorrow, { raw: "yyyy-MM-dd" }),
      isoStartDate: l10n.formatDateString(tomorrow, { raw: "yyyy-MM-dd" }),
    };
  }

  if (modelKey === "today") {
    const today = new Date();
    const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);

    return {
      ...model[modelKey],
      isoStartDate: l10n.formatDateString(today, { raw: "yyyy-MM-dd" }),
      isoEndDate: l10n.formatDateString(tomorrow, { raw: "yyyy-MM-dd" }),
    };
  }

  return model[modelKey];
}

export function getLink(content: Deal, modelKey: string) {
  const link = content.link;

  return modelKey === "today" ? `${link}&startDate=${content.isoStartDate}&endDate=${content.isoEndDate}` : link;
}
